import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectItem, SelectItemGroup } from 'primeng/api';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { AcModel } from 'projects/core/src/lib/models/ac.model';
import { BusinessunitModel } from 'projects/core/src/lib/models/businessunit.model';
import { Subscription } from 'rxjs';

const NA_VALUE = '** N/A **';
const DISABLED = {
  planned: ['hasjob', 'jobtitle', 'recruiter', 'businessunit'],
  running: ['hasjob', 'jobtitle', 'recruiter', 'businessunit'],
  finished: ['hasjob', 'jobtitle', 'recruiter', 'businessunit'],
  cancelled: ['hasjob', 'jobtitle', 'recruiter', 'businessunit'],
};

@Component({
  selector: 'app-order-detail-jobinformation',
  templateUrl: './order-detail-jobinformation.component.html',
  styleUrls: ['./order-detail-jobinformation.component.scss']
})
export class OrderDetailJobinformationComponent implements OnInit, OnChanges, OnDestroy {

  @Input() form: UntypedFormGroup;
  @Input() options: { [key: string]: Array<SelectItem | SelectItemGroup> };
  @Input() texts: { [key: string]: string };
  @Input() order: AcModel = null;
  @Input() mode: DetailModes | null;
  @Input() inEdit: boolean;
  @Input() submitting: boolean;

  @Output() changed = new EventEmitter<BusinessunitModel>();

  public naValue = NA_VALUE;

  private subForm: UntypedFormGroup = this.fb.group({
    hasjob: new UntypedFormControl(false),
    jobtitle: new UntypedFormControl({
      value: NA_VALUE,
      disabled: true
    }),
    recruiter: new UntypedFormControl(''),
    businessunit: new UntypedFormControl(''),
  });
  private subscriptions: Array<Subscription> = [];

  constructor(
    private fb: UntypedFormBuilder,
    private helper: HelperService
  ) { }

  ngOnInit(): void {
    this.form.addControl('jobinformation', this.subForm);
    this.subscriptions.push(this.subForm.get('hasjob').valueChanges.subscribe((value: any) => {
      if (value === true) {
        this.subForm.get('jobtitle').enable();
        this.subForm.get('jobtitle').setValidators([Validators.required]);
        this.subForm.get('jobtitle').updateValueAndValidity();
        if (this.subForm.get('jobtitle').value === NA_VALUE) {
          this.subForm.get('jobtitle').setValue('');
        }
      } else {
        this.subForm.get('jobtitle').disable();
        this.subForm.get('jobtitle').clearValidators();
        this.subForm.get('jobtitle').setValue(NA_VALUE);
      }
    }));
    this.subscriptions.push(this.subForm.get('businessunit').valueChanges.subscribe((value: any) => {
      this.changed.emit(value);
    }));
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.order || changes.inEdit) {
      this.initForm();
      FormHelper.disableForm(this.subForm, this.order?.status, DISABLED);
    }
  }

  ngOnDestroy(): void {
    this.helper.unsetSubscriptions(this.subscriptions);
  }

  public getPayload(): any {
    return {
      jobtitle: (this.subForm.get('hasjob').value === true) ? this.subForm.get('jobtitle').value : null,
      recruiter: this.subForm.get('recruiter').value,
      businessunit: this.subForm.get('businessunit').value?.id,
    };
  }

  public getBusinessValueName(): string {
    return this.subForm.get('businessunit').value?.name || '';
  }

  private initForm(): void {
    if (this.order) {
      this.subForm.patchValue({
        hasjob: !!this.order.misc?.order?.jobtitle,
        jobtitle: this.order.misc?.order?.jobtitle || NA_VALUE,
        recruiter: this.order.misc?.order?.recruiter,
        businessunit: this.getInitBusinessUnit(this.order.businessunit_id) || '',
      });
    }
  }

  private getInitBusinessUnit(id?: number | string): BusinessunitModel | null {
    let value = null;
    const target = Number(id);
    if (id === null || id === undefined || id === '' || isNaN(target)) {
      return null;
    }
    this.options.businessunits.forEach((parent: SelectItemGroup) => {
      if (Number(parent.value?.id) === target) {
        value = parent.value;
      } else {
        parent.items.forEach((child: SelectItem) => {
          if (Number(child.value?.id) === target) {
            value = child.value;
          }
        });
      }
    });
    return value;
  }

}
